import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';

import { accessLocalStorage, readInterfaces } from '../../../services';
import TableInterfaces from './TableInterfaces';

import '../../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';

function ListInterfaces() {
  const getItensStateGlobal = useContext(PbxContext);

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [interfaces, setInterfaces] = useState([]);
  const [fullDataIfaces, setFullDataIfaces] = useState({});

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    const getNetworkData = await readInterfaces();
    const filterIfaces = getNetworkData.map((element) => {
      delete element['lo'];
      return element;
    });
    
    setInterfaces(Object.keys(...filterIfaces))
    setFullDataIfaces(...filterIfaces)
  }, []);

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div>
      <div className="columns has-text-centered mt-4">
        <div className="column is-half is-offset-one-quarter has-text-centered">
          <strong className="is-size-3">Interfaces</strong>
          <hr className="dropdown-divider"/>
        </div>
      </div>
        <div className="columns is-fullwidth mx-2">
          <div className="column tabs is-flex-wrap-wrap is-fullwidth">
            <table id="tableCalls" className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">  
              <thead>
                <tr className='is-size-4 has-text-centered has-background-link-light'>
                  <th scope="col">Nome</th>
                  <th scope="col" >MAC</th>
                  <th scope="col">IP</th>
                  <th scope="col">Status</th>
                  <th scope="col">Conexão</th>
                </tr>
            </thead>
            <tbody>
                {
                  Object.values(fullDataIfaces).length > 0 ? interfaces.map((call) => <TableInterfaces key={ call } iface={{ iface: call, ...fullDataIfaces[call] }} />) : null
                }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ListInterfaces;
